<template>
  <v-app id="vapp">
    <router-view />
  </v-app>
  <metainfo>
  </metainfo>
</template>

<script>
import { useMeta } from 'vue-meta'
import { useLocale } from "vuetify";
import { watch } from 'vue';
import Lenis from 'lenis'

export default {
  name: 'App',
  setup() {
    window.LenisMain = new Lenis({
      autoRaf: true,
    });

    /* lenis.on('scroll', (e) => {
    }); */

    let data = {
      ru: {
        title: "Элегантные Таунхаусы и Виллы рядом с Вероной – Borgo Olistico",
        description: "Borgo Olistico – современные таунхаусы недалеко от Вероны. Просторные планировки, панорамные виды, частные сады и эксклюзивные зоны отдыха создают комфорт и удобство для жизни.",
      },
      en: {
        title: "Elegant Townhouses & Villas Near Verona – Borgo Olistico",
        description: "Discover Borgo Olistico, a prestigious townhouses and villa near Verona offering stylish homes with modern comfort, spacious layouts, panoramic views, private gardens, and exclusive recreational areas.",
      },
      it: {
        title: "Eleganti Villette e Townhouse Vicino Verona – Borgo Olistico",
        description: "Scopri Borgo Olistico, un esclusivo complesso di townhouse vicino a Verona. Spazi ampi e funzionali, viste panoramiche, giardini privati e aree ricreative esclusive per un comfort senza compromessi.",
      },
    };

    const locale = useLocale();
    useMeta({
      htmlAttrs: {
        lang: locale.current.value,
      },
      title: data[locale.current.value].title,
      description: data[locale.current.value].description,
      meta: [
        { vmid: 'description', name: 'description', content: data[locale.current.value].description }
      ]
    })

    watch(locale.current, (newLocale) => {
      document.title = data[newLocale].title;
      document.documentElement.lang = newLocale;
      const metaDescription = document.querySelector('meta[name="description"]');
      (metaDescription) && metaDescription.setAttribute('content', data[newLocale].description);
    });

    return {
      locale,
    };
  },
  data: () => ({
    //
  }),
  created() {
    this.$store.dispatch('Get_all_translation');
  },
}
</script>
<style>
/* Чёрный фон, который будет уходить вверх */
.btn-actions-dark::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #2A3228;
  transition: transform 0.3s ease;
  z-index: 1;
}

/* Белый фон, который появляется снизу */
.btn-actions-dark::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: #E2DFD9;
  transition: transform 0.3s ease;
  z-index: 0;
}

/* При наведении */
.btn-actions-dark:hover::before {
  transform: translateY(-100%);
  /* Чёрный фон уходит вверх */
}

.btn-actions-dark:hover::after {
  transform: translateY(-100%);
  /* Белый фон поднимается снизу */
}

.btn-actions-dark:hover {
  color: #2A3228 !important;
}

.btn-actions-dark:hover path {
  stroke: #2A3228;
}

.btn-actions-dark .v-btn__content,
.btn-actions-dark .v-btn__prepend,
.btn-actions-dark .v-btn__append {
  position: relative;
  z-index: 2;
}

.btn-actions-dark {
  /*  color="#2A3228" */
  color: #F7F5F1 !important;
  border-radius: 72px !important;
  line-height: 0px !important;
  font-weight: 400 !important;
  text-transform: inherit !important;
  font-size: 0.94rem !important;
  letter-spacing: 0rem !important;
  overflow: hidden;
  transition: color 0.3s ease;
  border: 2px solid #2A3228 !important;
}

.btn-actions-dark.v-btn--disabled {
  opacity: 0.7 !important;
}




/* */




/* Чёрный фон, который будет уходить вверх */
.btn-actions-white::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #E2DFD9;
  transition: transform 0.3s ease;
  z-index: 1;
}

/* Белый фон, который появляется снизу */
.btn-actions-white::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: #2A3228;
  /*  */
  transition: transform 0.3s ease;
  z-index: 0;
}

/* При наведении */
.btn-actions-white:hover::before {
  transform: translateY(-100%);
  /* Чёрный фон уходит вверх */
}

.btn-actions-white:hover::after {
  transform: translateY(-100%);
  /* Белый фон поднимается снизу */
}

.btn-actions-white:hover {
  background: #2c2c2c;
  color: #E2DFD9 !important;
}

.btn-actions-white:hover path {
  stroke: #E2DFD9;
}

/* Содержимое кнопки поверх фона */
.btn-actions-white .v-btn__content,
.btn-actions-white .v-btn__prepend,
.btn-actions-white .v-btn__append {
  position: relative;
  z-index: 2;
}

.btn-actions-white {
  /* color="#E2DFD9" */
  color: #2A3228 !important;
  border-radius: 72px !important;
  font-size: 0.95rem !important;
  line-height: 0px !important;
  font-weight: 400 !important;
  text-transform: inherit !important;
  letter-spacing: 0rem !important;
  overflow: hidden;
  transition: color 0.3s ease;
  border: 2px solid #E2DFD9 !important;
}

.btn-actions-dark .v-btn__prepend,
.btn-actions-white .v-btn__prepend {
  will-change: transform;
}

.btn-actions-dark .v-btn__append,
.btn-actions-white .v-btn__append {
  will-change: transform;
}

.tag-text {
  color: #2A3228;
  font-weight: 300;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.07rem;
}

@media screen and (max-width: 600px) {
  .btn-actions-white {
    font-size: 0.85rem;
    letter-spacing: 0.02rem;
  }

  .tag-text {
    font-size: 0.85rem;
    letter-spacing: 0.06rem;
  }

}
</style>
<style scoped>
#vapp {
  background: #F7F5F1;
  overflow-x: hidden;
}
</style>